import { render } from "./Stakeholders.vue?vue&type=template&id=4259a901&scoped=true&ts=true"
import script from "./Stakeholders.vue?vue&type=script&lang=ts"
export * from "./Stakeholders.vue?vue&type=script&lang=ts"

import "./Stakeholders.vue?vue&type=style&index=0&id=4259a901&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4259a901"]])

export default __exports__